<template>
  <el-container class="BomView">
    <el-main class="p-0 pb-default">
      <el-form
        ref="form"
        class="form-label-80"
        label-width="80px"
        :model="data"
      >
        <el-row>
          <el-col :span="12">
            <el-form-item label="품목" prop="product_id">
              <AProductSelector
                class="readonly"
                :value="data.product_name"
                :clearable="false"
                readonly
              />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="규격" prop="size">
              <el-input v-model="data.size" class="readonly" readonly />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="생산번호" prop="code">
              <el-input v-model="data.code" class="readonly" readonly />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="사양" prop="specification">
              <el-input
                v-model="data.specification"
                class="readonly"
                readonly
              />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="계획일" prop="plan_date">
              <ADatePicker v-model="data.plan_date" class="readonly" readonly />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="계획수량" prop="plan_amount">
              <ANumberInput
                v-model="data.plan_amount"
                class="readonly"
                readonly
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="거래처명" prop="customer_name">
              <ACustomerSelector
                class="readonly"
                :value="data.customer_name"
                :clearable="false"
                readonly
              />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="납기일" prop="delivery_date">
              <ADatePicker
                v-model="data.delivery_date"
                class="readonly"
                readonly
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="비고" prop="desc">
              <el-input v-model="data.desc" class="readonly" readonly />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row
          v-if="
            data.options &&
              data.options.specifications &&
              (data.options.specifications.length > 0 ||
                data.options.descriptions.length)
          "
        >
          <el-col :span="24">
            <el-form-item label="옵션" prop="desc">
              <el-tag
                v-for="item in data.options.specifications"
                type="danger"
                class="mr-default"
                :key="item.name"
                effect="dark"
              >
                {{ item.name }}
              </el-tag>
              <el-tag
                v-for="item in data.options.descriptions"
                type="primary"
                class="mr-default"
                :key="item.name"
                effect="dark"
              >
                {{ item.name }}
              </el-tag>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <el-tabs ref="tabs" v-model="active_tab" type="card">
        <el-tab-pane label="생산지시" name="1">
          <div
            class="bomtree-container flex of-auto"
            style="max-height: 400px;"
          >
            <div class="flex-fixed of-auto" style="width: 500px;">
              <AProductionBomTree ref="tree" :data="data.detail" />
            </div>
            <div class="flex-auto of-auto">
              <ABomTable :production="production" :material="material" />
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="품번조회" name="2">
          <SerialView :id="data.contract_detail_id" />
        </el-tab-pane>
      </el-tabs>
    </el-main>
    <el-footer>
      <el-button class="close-button" @click="handleCloseDialog"
        >{{ $t("button.close") }}(Esc)</el-button
      >
    </el-footer>
  </el-container>
</template>
<script>
import { form } from "@/common/mixins/form";
import { production_process } from "@/common/mixins/production_process";
import AProductionBomTree from "@/shared/AProductionBomTree";
import SerialView from "@/spa/Common/SerialView";

export default {
  name: "BomView",
  mixins: [form, production_process],
  components: { AProductionBomTree, SerialView },
  data() {
    return {
      title: "생산 지시",
      production_item: {},
      // 객체가 깊어지는 경우 변경이 감지되지 않아서 변수로 선언하여 사용
      bom: [],
      active_tab: "1",
    };
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  computed: {
    production() {
      if (!this.data.detail) {
        return [];
      }
      return this.data.detail.production;
    },
    material() {
      if (!this.data.detail) {
        return [];
      }
      return this.data.detail.material;
    },
  },
  methods: {
    // Contract Detail 정보로 생산 지시 정보를 생성
    loadSource() {
      let param = { id: this.source.contract_id };
      this.api.listProductionContract(param).then((res) => {
        let data;
        if (res.data.length > 0) {
          data = res.data.forEach(
            (d) => d.contract_detail_id === this.source.id
          );
          if (data) {
            this.data = Object.assign({}, data);
            this.data.detail = {
              bom: [],
              production: [],
              material: [],
            };
          }
        }
        if (!data) {
          this.data = {
            id: 0,
            code: "",
            contract_id: this.source.contract_id,
            contract_detail_id: this.source.id,
            plan_date: this.util.getDate(),
            delivery_date: this.util.getDate(1),
            customer_id: this.source.customer_id,
            customer_name: this.source.customer_name,
            plan_amount: this.source.amount,
            product_id: this.source.product_id,
            product_name: this.source.product_name,
            size: this.source.size,
            status_flag: "0",
            detail: {
              bom: [],
              production: [],
              material: [],
            },
          };
        }
      });
    },
    doRegister() {
      let items = [this.data];
      this.processProduction(
        "생산 등록 중입니다.",
        () => this.api.registerProduction(items),
        { success: (res) => this.handleResponse(res, "등록되었습니다.") }
      );
    },
    doDelete() {
      let params = [this.data.id];
      this.processProduction(
        "생산 취소 중입니다.",
        () => this.api.deleteProduction(params),
        { success: (res) => this.handleResponse(res, "삭제되었습니다.") }
      );
    },
    handleBomTreeCompleted(result) {
      // 생산 대기중이 아니리면 업데이트 하지 않는다.
      if (this.data.status_flag !== "0") {
        return;
      }
      this.data.detail = result;
      this.bom = Object.assign([], result.bom);
      this.production = Object.assign([], result.production);
      this.material = Object.assign([], result.material);
    },
    // handleClickRegister() {
    //   let isValid = true;
    //   this.items.forEach(item => {
    //     if (!isValid) { return false; }
    //             if (!item.plan_date) {
    //       this.util.notify_warning(this, this.title,
    //       item.product_name + " 계획일을 선택해 주세요.");
    //       isValid = false;
    //     }
    //     if (!isValid) { return false; }
    //     if (item.detail.bom.length < 1) {
    //       this.util.notify_warning(this, this.title,
    //       item.product_name + " 생산 계획을 선택해 주세요.");
    //       isValid = false;
    //     }
    //   })
    //   if (!isValid) { return; }
    //   this.api.registerProduction(this.items).then(res => {
    //     if (res.error !== this.system.noError) {
    //       this.util.notify_response_error(this, this.title, res);
    //       return;
    //     }
    //     this.util.notify_success(this, this.title, "등록되었습니다.");
    //   this.$emit('completed', true);
    //   });
    // },
    handleSelectProduct(product) {
      if (!product || typeof product === "string") {
        this.data.product_id = undefined;
        this.production = [];
        this.material = [];
      } else {
        this.data.product_id = product.id;
        this.data.product_name = product.name;
        this.data.size = product.size;
      }
    },
    handleSelectCustomer(customer) {
      if (!customer || typeof customer === "string") {
        this.data.customer_id = undefined;
      } else {
        this.data.customer_id = customer.id;
        this.data.customer_name = customer.name;
      }
    },
    handleClickRegister() {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return;
        }
        if (this.data.detail.bom.length < 1) {
          this.util.notify_warning(
            this,
            this.title,
            "BOM이 등록된 품목을 선택해 주세요."
          );
          return;
        }
        this.doRegister();
      });
    },
    handleClickDelete() {
      this.util.confirm_delete(this, this.title, this.doDelete);
    },
    handleCloseDialog() {
      this.$emit("completed");
    },
    handleResponse(res, message) {
      if (res.error !== this.system.noError) {
        this.util.notify_response_error(this, this.title, res);
        return;
      }
      this.util.notify_success(this, this.title, message);
      this.$emit("completed", true);
    },
  },
};
</script>

<style lang="scss">
.BomView {
  .bomtree-container {
    max-height: 400px;
    overflow: auto;
  }
}
</style>
